export const API_URL = 'https://api-qrinvite.technext.ao/api';
